// extracted by mini-css-extract-plugin
export default {"heading":"Heading-module__heading___FnXDk","title":"Heading-module__title___Eus5L","headingCtaLink":"Heading-module__headingCtaLink___8HLCD","cta":"Heading-module__cta___x4VfA"};